import '@fontsource/b612/400.css';
import '@fontsource/b612/700.css';
import '@fontsource/b612-mono/400.css';
import '@fontsource/b612-mono/700.css';
import './app.css';
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router';
import { LOCAL_USER } from '@war-game/local-server/client';
import { ApiRequestError } from '@war-game/contracts';
import { refreshSession } from './api/client';
import { initObservability } from './lib/observability';
import { syncServerTime } from './lib/time';
import { App } from './routes/App';
import { useAuth } from './store/auth';

import { PRODUCT_NAME, STANDALONE } from './platform';

if (!STANDALONE) initObservability(import.meta.env.VITE_SENTRY_DSN as string | undefined);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => !(error instanceof ApiRequestError && error.status < 500) && count < 2,
      refetchOnWindowFocus: true,
    },
  },
});

if (STANDALONE) {
  // Sem conta nem rede: o jogador local já entra "logado"; o relógio é o do jogo.
  document.title = PRODUCT_NAME;
  useAuth.getState().setSession('local', LOCAL_USER);
} else {
  void syncServerTime();
  void refreshSession().finally(() => useAuth.getState().setReady());
  if ('serviceWorker' in navigator && import.meta.env.PROD) void navigator.serviceWorker.register('/sw.js');
}

/** Standalone abre de arquivo (desktop) ou de qualquer pasta: rotas no hash (#/partidas/...). */
const Router = STANDALONE ? HashRouter : BrowserRouter;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <App />
      </Router>
    </QueryClientProvider>
  </StrictMode>,
);
